import { Box, LinearProgress } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default function ScreenLoader() {
  const { t } = useTranslation();
  return (
    <div>
      <LinearProgress />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h3>{t("authenticating_user")}</h3>
      </Box>
    </div>
  );
}
